import React from "react";

import {
	formatDate,
  returnDate,
  convertToSlug,
  redirectionWrapper,
  getAssociationUrlPrefix,
	sanitizeAndProcessHtml
} from "../../../util/commonFunctions";
import { showLoader, hideLoader } from "../../../actions";
import { getContentWithLanguage } from "../../../util/language";
import LazyLoad from 'react-lazyload';

function EventListingComponent({type , listing = [], isColumn = false, currentLanguage}){

	if(listing.length > 0) {

		return listing.map((event, index) => {
			let item = getContentWithLanguage(event, currentLanguage);
			let date = formatDate(item.event_date);

			let redirectUrl = getAssociationUrlPrefix(item.associationType);
			let associationId = item.associationId == null ? item.topic?.id : item.associationId;
			let associationName = item.associationName == null ? item.topic?.name : item.associationName;
			let about = sanitizeAndProcessHtml(item.about);
			return (
				<React.Fragment key={item.id}>
					<div className={`${isColumn ? "column-item" :  "col-12 col-sm-6 col-md-4 col-lg-3"}`}>
						<figure className="item">
							<a
								href={"/event/" +
									convertToSlug(item.title) +
									"?eventId=" +
									item.id
								}
							>
								<LazyLoad
									offset={50}
									once={true}
									key={index}
									height={200}
									placeholder={<img src="/assets/svg/abiz_placeholder.svg" className="img-fluid" />}
									debounce={500}
									className={isColumn ? "col-12 col-md-4" : ""}
								>
									<img
										src={item.event_image_file_base.path}
										className="figure-img img-fluid"
										alt={"Ausbiz event: " + item.title + " thumbnail"}
										width="1024px"
										height="576px"
									/>
								</LazyLoad>
								<div className={`${isColumn ? "col-12 col-md-8" : ""} list-event-description`}>
									{<div dangerouslySetInnerHTML={{ __html: about}}></div>}
								</div>
							</a>
							<div className="text-left">
								<a 
									style={{ color: "#333" }} 
									href={
										"/event/" +
										convertToSlug(item.title) +
										"?eventId=" +
										item.id
									}
								>
									<h4 className="event-list-item-title">{item.title}</h4>
								</a>
								<ul className="d-flex flex-row justify-content-between vod_com_time">
									<li className={item.following ? "video-verified" : null}>
										<a
											style={{ color: "#333" }} 
											href={`/${redirectUrl}/${associationName}/${associationId}`}
											onClick={event => {
												redirectionWrapper(
													redirectUrl,
													event,
													associationId,
													associationName,									
													showLoader,
													hideLoader,
													currentLanguage
												)
											}
											}
										>
											{associationName}
										</a>
									</li>
									<li>{returnDate(date)}</li>
								</ul>
							</div>
						</figure>
					</div>
				
				</React.Fragment>
			);
		})
	}else {
		return <div className="no-events"> No {type} </div>
		
	}
	
};

export  { EventListingComponent };
